export const splitCardDigits = (prefix: string, suffix: string) => {
  const digits = `${prefix}******${suffix}`
  const t1 = digits.slice(0, 4)
  const t2 = digits.slice(4, 8)
  const t3 = digits.slice(8, 12)
  const t4 = digits.slice(12, 16)

  return `${t1} ${t2} ${t3} ${t4}`
}
